<template>
    <div class="list-item-with-title">
        <f7-block-title>{{ title }}</f7-block-title>
	      <slot name="after-title" />
        <f7-list dividers-ios strong-ios outline-ios>
            <f7-list-input
                :disabled="disabled"
                :type="textarea ? 'textarea' : 'text'"
                :placeholder="placeholder"
                v-model:value="text"
                :clear-button="!disabled && showClearButton"
                :rows="textarea ? 2 : 1"
                @update:value="updateValue"
								@input:clear="clearInputHandler"
								@blur="blurInputHandler"
            >
							<template #content-end>
								<slot name="content-end" />
							</template>
						</f7-list-input>
            <p ref="errorEl" v-if="error" class="list-item-with-title_error">{{ errorText }}</p>
            <p v-if="hint" class="list-item-with-title_hint" v-html="hint"></p>
        </f7-list>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps({
    title: {
        type: String,
        required: true
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false
    },
    text: {
        type: String,
        required: true
    },
    placeholder: {
        type: String,
        required: true
    },
    textarea: {
        type: Boolean,
        required: false,
        default: false
    },
    required: {
        type: Boolean,
        required: false,
        default: false
    },
    hint: {
        type: String,
        required: false
    },
	showClearButton: {
		type: Boolean,
		default: true
	}
});

function updateValue() {
    error.value = false;
}

const errorEl = ref(null);
const text = defineModel<string>("text", {
    required: true
});

const error = ref(false);
const errorText = ref("");
const emits = defineEmits(["onItemClick", "onClear", "onBlur"]);
defineExpose({error, text, errorEl, errorText})

const clearInputHandler = () => {
	emits('onClear')
}

const blurInputHandler = () => {
	emits('onBlur')
}
</script>

<style lang="scss">
.list-item-with-title {
    margin-top: 32px;

    .block-title {
        margin-top: 0;
        text-transform: uppercase;
        @include text(12px, 400, var(--grey2), 14.4px);
    }

    .list {
        margin: 0;

        ul {
            & + .list-item-with-title_hint {
                margin-top: 6px;
            }
        }

    }

    .item-input-wrap:has(.input-clear-button) input,
    .item-input-wrap:has(.input-clear-button) textarea {
      padding-right: 1.5rem !important;
    }

    &_error {
        padding: 6px 16px;
        @include text(12px, 400, var(--red1), 14.4px);
    }

    &_hint {
        padding: 0 16px;
        @include text(12px, 400, var(--grey2), 14.4px);
    }
}
</style>
